export const SISMEDIA_ID_GW = '1';
export const SISMEDIA_ID_MS = '2';
export const SISMEDIA_ID_GF = '3';

// Summer: Region Overview is custom
export const SISMEDIA_ID_JR = '99';

export const SISMEDIA_LIFT_ID_SEGMENT_ZWEILUETSCHINEN_GRINDELWALD = '1004';
export const SISMEDIA_LIFT_ID_SEGMENT_INTERLAKEN_OST_ZWEILUETSCHINEN = '1501';
export const SISMEDIA_LIFT_ID_SEGMENT_ZWEILUETSCHINEN_GRINDELWALD_2 = '1502';
export const SISMEDIA_LIFT_ID_SEGMENT_ZWEILUETSCHINEN_LAUTERBRUNNEN = '1503';
export const SISMEDIA_LIFT_ID_SEGMENT_WILDERSWIL_SCHYNIGE_PLATTE = '1504';
export const SISMEDIA_LIFT_ID_SEGMENT_INTERLAKEN_HARDER_KULM = '1505';

export const SISMEDIA_TRACK_ID_EIGERGLETSCHER_KLEINE_SCHEIDEGG = '1003';
export const SISMEDIA_TRACK_ID_FIRST_FLIEGER_SOMMER = '1007';
export const SISMEDIA_TRACK_ID_FIRST_BACHALPSEE_SOMMER = '1008';
export const SISMEDIA_TRACK_ID_EGGBODEN_YELLOW = '1102';

export const SISMEDIA_TRACK_ID_WENGERNALP_36B = '192';
export const SISMEDIA_TRACK_ID_WENGERNALP_36A_CUSTOM = '193';
